export default function AppButton({
  title,
  onClick,
  isBtnGreen = false,
  isBtnRed = false,
  disabled = false
}) {
  return (
    <button
      className={`app-btn btn ${isBtnGreen ? "btn-Vlight-green" : "btn-green"} ${isBtnRed && "btn-danger"}`}
      onClick={onClick}
      disabled={disabled}
    >
      {title}
    </button>
  );
}
